import { useEffect, useState } from 'react'

import { BUTTON_TYPES, GetStartedButton, OpenTwistButton } from 'components'

import css from './FooterCTA.module.css'
import adaptive from 'styles/adaptive.module.css'

export default function FooterCTA() {
    const [loggedIn, setLoggedInStatus] = useState(false)

    /** Hide "Get Started" button when user is logged in and show "Open Twist" */
    useEffect(() => {
        /** On some platforms (Mobile Safari when old/incognito) localStorage is unavailable */
        if (localStorage?.getItem) {
            setLoggedInStatus(Boolean(localStorage.getItem('session_user')))
        }
    }, [])

    return (
        <div className={css.ctaContainer}>
            <div className={adaptive.container}>
                <img src={require('public/assets/remote-work-guides/get-started.png')} />

                <div>
                    <h3>Productive teamwork starts with productive communication</h3>
                    <p>Try Twist for free.</p>

                    {loggedIn ? (
                        <OpenTwistButton type={BUTTON_TYPES.SMALL} />
                    ) : (
                        <GetStartedButton type={BUTTON_TYPES.SMALL} />
                    )}
                </div>
            </div>
        </div>
    )
}
